/* NAILZ: Video tutorial
   - El video de fondo se reproduce (mudo) solo cuando el recuadro está en pantalla.
   - Al apretar play se abre un <dialog> con fondo negro, el video con sonido y una X para cerrar.
   - Se cierra con la X, con Escape o tocando fuera del video. */
if (!customElements.get('nailz-video-tutorial')) {
  customElements.define(
    'nailz-video-tutorial',
    class NailzVideoTutorial extends HTMLElement {
      connectedCallback() {
        this.modal = this.querySelector('[data-nz-vt-modal]');
        this.openButton = this.querySelector('[data-nz-vt-open]');
        this.background = this.querySelector('.nz-vt__bg-video');
        this.setUpBackground();
        if (!this.modal || !this.openButton) return;

        this.player = this.modal.querySelector('.nz-vt__player video');
        this.frame = this.modal.querySelector('.nz-vt__player iframe');

        this.openButton.addEventListener('click', () => this.open());
        this.modal.querySelector('[data-nz-vt-close]').addEventListener('click', () => this.modal.close());
        this.modal.addEventListener('click', (event) => {
          if (!event.target.closest('.nz-vt__player, [data-nz-vt-close]')) this.modal.close();
        });
        this.modal.addEventListener('close', () => this.onClose());
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.modal && this.modal.open) this.modal.close();
      }

      setUpBackground() {
        if (!this.background) return;
        this.background.muted = true;
        this.background.playsInline = true;
        this.background.removeAttribute('controls');
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const playing = this.background.play();
                if (playing) playing.catch(() => {});
              } else {
                this.background.pause();
              }
            });
          },
          { threshold: 0.25 }
        );
        this.observer.observe(this.background);
      }

      open() {
        if (this.background) this.background.pause();
        document.documentElement.classList.add('nz-vt-lock');
        this.modal.showModal();

        if (this.player) {
          this.player.playsInline = true;
          const playing = this.player.play();
          if (playing) playing.catch(() => {});
        } else if (this.frame && this.frame.dataset.src) {
          this.frame.src = this.frame.dataset.src;
        }
      }

      onClose() {
        document.documentElement.classList.remove('nz-vt-lock');
        if (this.player) this.player.pause();
        if (this.frame) this.frame.removeAttribute('src');
        if (this.background && this.observer) {
          const rect = this.background.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < window.innerHeight) {
            const playing = this.background.play();
            if (playing) playing.catch(() => {});
          }
        }
      }
    }
  );
}
